import React, { createRef, useEffect, useState } from "react";
import {
  makeStyles,
  Divider,
  Chip,
  Container,
  Box,
  Card,
  CardHeader,
} from "@material-ui/core";

import MaterialTable from "material-table";

import { useSelector, useDispatch } from "react-redux";

import { AlertTitle, Alert } from "@material-ui/lab";
import _ from "lodash";
import {
  getAllRoles,
  getAllUsers,
  updateUserRole,
  updateMultipleUserRole,
  updateUserApprover,
} from "src/redux/actions/backOffice.action";
import Swal from "sweetalert2";
import { httpClient } from "src/utils/HttpClient";
import Page from "src/components/Page";
import Toolbar from "./Toolbar";
import { hasRole } from "src/utils/Auth";
import { getAllApprovers } from "src/redux/actions/backOffice.action";

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    overflow: "hidden",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  inputForm: {
    margin: theme.spacing(1, 1, 1),
    width: "25ch",
  },
  buttonForm: {
    margin: theme.spacing(0, 1, 0),
  },
}));

const UserManagementSettingComponent = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const tableRef = createRef();
  const [selectedRow, setSelectedRow] = useState(null);
  const { users, roles, approvers } = useSelector(
    (state) => state.backOfficeReducer
  );
  const { authorizePR } = useSelector((state) => state.authorizationReducer);

  useEffect(() => {
    dispatch(getAllRoles());
    dispatch(getAllUsers());
    dispatch(getAllApprovers());
  }, []);

  const renderLookupRole = () => {
    if (roles.data) {
      if (hasRole(authorizePR.data, ["admin"])) {
        let obj = _.filter(roles.data, function (o) {
          return o.NAME !== "super-admin";
        }).reduce(function (acc, cur, i) {
          acc[cur.ID] = cur.NAME;
          return acc;
        }, {});

        return obj;
      } else {
        let obj = roles.data.reduce(function (acc, cur, i) {
          acc[cur.ID] = cur.NAME;
          return acc;
        }, {});

        return obj;
      }
    }

    return {};
  };

  const renderLookupApprovers = () => {
    if (approvers.data) {
      let obj = approvers.data.reduce(function (acc, cur, i) {
        acc[cur.PER_ID] = cur.FULLNAME;
        return acc;
      }, {});
      return obj;
    }
    return {};
  };

  if (users.isRejected) {
    return (
      <div className={classes.root}>
        <Alert severity="error">
          <AlertTitle>Error</AlertTitle>
          This is an error alert — <strong>Get Users data!</strong>
        </Alert>
      </div>
    );
  }

  return (
    <Page className={classes.root} title="User Management">
      <Container maxWidth="xl">
        <Box mb={2}>
          <Card>
            <CardHeader
              subheader="For user management on the system."
              title="User Management"
            />
            <Divider />
          </Card>
        </Box>
        <Box mb={2}>
          <Toolbar
            onSubmit={(value) => {
              if (selectedRow) {
                dispatch(updateMultipleUserRole(value.ROLE, selectedRow));
              }
            }}
            roles={roles.data}
          />
        </Box>
        <MaterialTable
          title
          ref={tableRef}
          isLoading={users.isLoading || roles.isLoading}
          columns={[
            {
              title: "Name",
              field: "PER_FULLNAME",
              editable: false,
              filtering: false,
            },
            {
              title: "Email Address",
              field: "PER_EMAIL",
              editable: false,
              filtering: false,
            },
            {
              title: "Role",
              field: "ROLEs",
              render: (rowData) => {
                if (rowData.ROLEs[0] !== undefined) {
                  return rowData.ROLEs.map((e) => e.NAME).join(",");
                }
                return "";
              },
              hidden: true,
              // export: true,
            },
            {
              title: "Role",
              field: "ROLE_ID",
              lookup: renderLookupRole(),
              render: (rowData) => {
                return (
                  rowData.ROLES &&
                  rowData.ROLES.map((i) => (
                    <Chip
                      label={i.NAME}
                      color="primary"
                      clickable
                      variant="outlined"
                      style={{
                        margin: 2,
                      }}
                      onDelete={(e) => {
                        e.preventDefault();
                        Swal.fire({
                          title: "Confirm to remove role from user ?",
                          text: "You won't be able to revert this!",
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonColor: "#3085d6",
                          cancelButtonColor: "#d33",
                          confirmButtonText: "Yes",
                        }).then((result) => {
                          if (result.isConfirmed) {
                            httpClient
                              .delete(
                                `/backoffice/user/role/${rowData.PER_ID}/${i.ID}`
                              )
                              .then((result) => {
                                Swal.fire({
                                  text: result.data.message,
                                  icon: "success",
                                }).then(() => {
                                  dispatch(getAllUsers());
                                });
                              })
                              .catch((err) => {
                                Swal.fire({
                                  text: err.message,
                                  icon: "error",
                                });
                              });
                          }
                        });
                      }}
                    />
                  ))
                );
              },
              filtering: false,
            },
            {
              title: "Approver",
              field: "APPROVERS",
              lookup: renderLookupApprovers(),
              render: (rowData) => {
                return (
                  rowData.USER_HAS_APPROVERs &&
                  rowData.USER_HAS_APPROVERs.map((i) => (
                    <Chip
                      label={i.PERSON.PER_FULLNAME}
                      color="secondary"
                      clickable
                      variant="outlined"
                      style={{
                        margin: 2,
                      }}
                      onDelete={(e) => {
                        e.preventDefault();
                        Swal.fire({
                          title: "Confirm to remove approver from user ?",
                          text: "You won't be able to revert this!",
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonColor: "#3085d6",
                          cancelButtonColor: "#d33",
                          confirmButtonText: "Yes",
                        }).then((result) => {
                          if (result.isConfirmed) {
                            httpClient
                              .delete(
                                `/backoffice/user/approver/${rowData.PER_ID}/${i.PERSON.PER_ID}`
                              )
                              .then((result) => {
                                Swal.fire({
                                  text: result.data.message,
                                  icon: "success",
                                }).then(() => {
                                  dispatch(getAllUsers());
                                });
                              })
                              .catch((err) => {
                                Swal.fire({
                                  text: err.message,
                                  icon: "error",
                                });
                              });
                          }
                        });
                      }}
                    />
                  ))
                );
              },
              filtering: false,
            },
          ]}
          data={
            hasRole(authorizePR.data, ["admin"])
              ? _.filter(users.data, function (o) {
                  return o.ORG_ID !== 176880;
                })
              : users.data
          }
          editable={{
            onRowUpdate: (newData, oldData) =>
              new Promise((resolve, reject) => {
                if (newData.APPROVERS) {
                  // Update
                  dispatch(
                    updateUserApprover(newData.PER_ID, {
                      APPROVER_ID: newData.APPROVERS,
                    })
                  );
                }

                setTimeout(() => {
                  dispatch(
                    updateUserRole(newData.PER_ID, {
                      ROLE_ID: newData.ROLE_ID,
                    })
                  );
                  resolve();
                }, 1000);
              }),
          }}
          options={{
            filtering: true,
            // actionsColumnIndex: -1,
            selection: true,
          }}
          onSelectionChange={(rows) => {
            setSelectedRow(rows);
          }}
        />
      </Container>
    </Page>
  );
};

export default UserManagementSettingComponent;
